function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M474.817,358.47c-37.959-9.551-84.027-22.663-93.519-27.538 c-5.333-4.303-33.054-37.242-33.054-37.242l-15.347-88.114c25.685,7.941,32.757,24.243,41.162,55.588 c2.272,8.451,9.925,14.052,18.276,14.052c1.617,0,3.266-0.206,4.912-0.642c10.093-2.7,16.098-13.105,13.381-23.189 c-23.296-104.037-133.777-88.719-134.029-88.704c-38.881,2.601-72.003-7.163-74.704-11.313 c-2.979-4.302-14.967-23.599-16.798-58.872c-0.538-10.447-9.505-18.522-19.887-17.923c-2.422,0.126-4.695,0.736-6.797,1.682 c6.992-7.422,11.343-17.351,11.343-28.347c0-22.919-18.567-41.495-41.487-41.495S86.798,24.986,86.798,47.906 c0,22.908,18.568,41.472,41.472,41.472c8.288,0,15.958-2.479,22.435-6.675c-2.312,3.337-3.631,7.384-3.421,11.752 c2.438,46.968,19.605,73.347,24.827,80.308c10.138,13.571,37.916,21.958,67.683,24.941c0.027,0.126,0.035,0.221,0.05,0.355 l23.308,111.236c0,0-5.983,61.539-3.846,77.337c0.878,6.667,3.175,24.373,72.631,91.419c4.736,4.585,10.887,6.873,17.012,6.873 c6.385,0,12.809-2.51,17.605-7.482c9.384-9.72,9.107-25.233-0.609-34.617c-24.037-23.252-58.183-64.406-58.183-64.406 s1.297-27.585,3.594-48.761c0.146-2.03,3.688-3.218,5.202-1.373c3.866,5.012,28.554,35.502,37.958,41.657 c14.646,9.565,74.181,25.409,108.354,33.991c2.007,0.521,4.021,0.766,5.996,0.766c10.938,0,20.917-7.4,23.717-18.53 C495.901,375.054,487.953,361.734,474.817,358.47z"
}), React.createElement("path", {
  d: "M280.697,154.994c26.333-5.649,43.123-31.574,37.471-57.892 c-5.638-26.333-31.552-43.104-57.877-37.456c-26.354,5.649-43.12,31.566-37.479,57.873 C228.456,143.852,254.371,160.631,280.697,154.994z"
}), React.createElement("g", null, React.createElement("path", {
  d: "M8.803,99.36L0,99.49l28.266,119.766l71.669-0.086l24.109-119.881L8.803,99.36z M90.997,212.564 l-2.571-5.005l-2.574,5.012l-7.159,0.008l6.156-11.986l-9.153-17.82l-9.152,17.82l6.16,11.994l-7.15,0.008l-2.586-5.036 l-2.589,5.042l-7.159,0.009l6.171-12.017l-9.152-17.82l-9.153,17.82l6.176,12.024l-7.15,0.009l-2.602-5.066l-2.605,5.072 l-1.398,0.002l-1.812-7.683l2.238-4.358l-6.037-11.755l-6.073-25.754l2.958,5.759l9.152-17.82l-9.152-17.821l-6.856,13.349 l-2.256-9.548l5.53-10.768L10.796,105.98l7.152-0.004l6.828,13.294l6.833-13.303l11.79-0.008l6.836,13.311l6.842-13.32 l11.772-0.008l6.845,13.328l6.851-13.337l11.754-0.008l6.854,13.345l6.859-13.354l7.157-0.005l-10.438,20.326l5.134,9.998 l-2.013,10.011l-6.699-13.043l-9.152,17.821l9.152,17.82l3.541-6.894l-4.604,22.895l-8.088,15.749l3.536,6.886l-1.021,5.081 L90.997,212.564z"
}), React.createElement("polygon", {
  points: "50.236,133.201 41.085,151.022 50.236,168.842 59.389,151.022 \t\t\t"
}), React.createElement("polygon", {
  points: "28.356,175.807 37.506,193.627 46.661,175.807 37.506,157.986 \t\t\t"
}), React.createElement("polygon", {
  points: "53.815,175.807 62.965,193.627 72.12,175.807 62.965,157.986 \t\t\t"
}), React.createElement("polygon", {
  points: "75.695,133.201 66.544,151.022 75.695,168.842 84.85,151.022 \t\t\t"
}), React.createElement("polygon", {
  points: "88.424,157.986 79.273,175.807 88.424,193.627 97.579,175.807 \t\t\t"
}), React.createElement("polygon", {
  points: "97.579,126.236 88.424,108.416 79.273,126.236 88.424,144.056 \t\t\t"
}), React.createElement("polygon", {
  points: "46.661,126.236 37.506,108.416 28.356,126.236 37.506,144.056 \t\t\t"
}), React.createElement("polygon", {
  points: "72.12,126.236 62.965,108.416 53.815,126.236 62.965,144.056 \t\t\t"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 493.337 493.337",
    style: {
      "enableBackground": "new 0 0 493.337 493.337"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/catched.480fb24a.svg";
export { SvgComponent as ReactComponent };